import { atom } from 'jotai';

export const isShoppingCartMenuOpenState = atom(false);
